<template>
  <div>
    <h6><i class="fas fa-university"></i>
    <router-link class="text-primary" event="" :to="{ name: 'organizationView', params: { id: item.id }}" @click.native.prevent="viewOrg">{{ item.name }}</router-link></h6>
    <p class="meta">
     <span class="meta-bit" v-if="item.country"> {{ item.country }}</span>
    </p>
    <p class="meta-desc" v-if="item.description">{{ item.description }}</p>
    <p>
      <OrgtypeLabel class="targ-label"  :target="itemtype" v-show="item"/>
    </p>
  </div>
</template>


<script>
import OrgtypeLabel from './OrgtypeLabel'
let parser = document.createElement('a')
export default {
  name: 'result',
  props: ['item'],
  components: { OrgtypeLabel },
  methods: {
    domainOf: url => ((parser.href = url), parser.hostname.replace(/^www\./, '')),
    viewOrg: function(){
        var event = new CustomEvent("openView", {
                detail: {
                  type:"Organisation",
                  id: this.item.id
                }
              });
          this.$emit('openView',event);
      }
      },
       computed: {
            itemtype(){
              return (this.item.type.constructor.name=="Array"? this.item.type.join() : this.item.type);
              
            }
       }
}
</script>

<style scoped>
  .meta {
    color: #777;
    font-size: .85em;
  }
  .meta-bit {
    color: #333;
    font-weight: bold;
  }
  
  .meta-desc{
    overflow:hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .fas{
    color:#afacac;
    margin-right:5px;
  } 

  .targ-label {
    margin-left: 0.4em;
    white-space: nowrap;
    padding: 3px 8px 3px 8px;
    border-radius: 25px;
    color: white;
    font-size: 12px;
    font-weight: bold;
    display: inline-block;
    margin-top: 1em;
  }
</style>


// WEBPACK FOOTER //
// src/plugins/SearchPlugin/components/OrgResult.vue